<template>
    <div class="content">
        <div class="main">
            <div class="ul">
                <span v-for="(item, index) in list" :key="index" class="block">
                    <span v-if="index+1===list.length">{{item.name}}</span>
                    <a v-if="index+1<list.length" :href="item.href">{{item.name}}</a>
                    <div :class="index+1<list.length?'sanjiao':''" class="subblock">
                        <span />
                    </div>
                </span>
                <!-- <span class="block">
                    文字内容
                    <div class="sanjiao">
                        <span />
                    </div>
                </span> -->
            </div>
            
        </div>
        
    </div>
</template>
<script>
export default {
    props:{
        list:{
            type:Array,
            default:() => [],
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    background: #F0F0F0;
    padding: 10px 0px 10px 0;
    font-size: 14px;
    color: #333333;
    .main{
        width: 1120px;
        margin: auto;
        .ul{
            background: #fff;
            display: inline-block;
        }
        
    }
}
a{
    color:#235483;
    cursor: pointer;
}
.block{
  position: relative;
  display: inline-block;
  height: 45px;
  line-height: 45px;
  padding-right: 35px;
  padding-left: 13px;
  background: #fff;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  .subblock{
      position: absolute;
      top:0px;
      right:0px;
      width: 28px;
      height: 46px;
      background: #F0F0F0;
      span{
          display: inline-block;
          border: 22.5px solid transparent;
          border-left: 22.5px solid #fff;
      }
  }
  .sanjiao:after{
    border: 15.5px solid transparent;
    border-left: 15.5px solid #fff;
    width: 0;
    height: 0;
    position: absolute;
    top: -15.5px;
    right: -15.5px;
    content: ' ';
    transform: rotate(-45deg);
  }
  .sanjiao:before{
    border: 15px solid transparent;
    border-left: 15px solid #fff;
    width: 0;
    height: 0;
    position: absolute;
    bottom: -14px;
    right: -15px;
    content: ' ';
    transform: rotate(45deg);
  }
}

</style>
